
import { ResourceModel } from "../../generics/models/generic-resource-model";

export class DevicePushToken extends ResourceModel<DevicePushToken> {
  public id: number;
  public token: string;
  public deviceIdentifier: string;
  public userID: number;

  constructor(model?: Partial<DevicePushToken>) {
    super(model);
  }
}
